module.exports = __webpack_public_path__ + "static/fonts/Mont-ExtraLightItalic.c377eda.woff2";